import Button from '@/components/elements/forms/buttons/Button/Button';
import ServiceCard from '@/components/elements/Card/ServiceListCard/ServiceListCard';
import { useListCardsV2 } from '@/hooks/useListCardsV2';
import useMobileView from '@/hooks/useMobileView';
import { _t } from '@/locale';
import LegacyServiceItem, { LegacyServiceItemProps } from './LegacyServiceItem';
import { useOpenServiceDetails } from './ServiceDetailsContext';

const bookAppointmentServiceItemKey = 'components.modules.modals.BookAppointment.shared.ServiceItem';

/** The `on*ServiceInfo` handlers only reach the legacy row; this one opens the details itself. */
type ServiceItemProps = LegacyServiceItemProps;

/** Service row via the shared ServiceCard; the row opens the service's details when a ServiceDetailsProvider offers them, else it picks. */
const ServiceItem = (props: ServiceItemProps) => {
  const { service, onPickService, ctaVariant = 'primary', ctaAction } = props;
  const { isMobileView } = useMobileView();
  const openServiceDetails = useOpenServiceDetails();
  const isListCardsV2 = useListCardsV2();
  const { isRecommended, ...cardData } = service;
  const pick = () => onPickService(service.id, isRecommended);
  const resolvedCtaAction = ctaAction ?? (isRecommended ? 'add' : 'book');
  const ctaLabel = _t(`${bookAppointmentServiceItemKey}.cta.label.${resolvedCtaAction}`);

  const showDetails = openServiceDetails
    ? () =>
        openServiceDetails(service.id, {
          label: _t(`features.bookingSelection.ServiceItem.infoCta.${resolvedCtaAction}`),
          onPick: pick,
        })
    : undefined;

  if (!isListCardsV2) {
    return <LegacyServiceItem {...props} />;
  }

  return (
    <li>
      <ServiceCard
        {...cardData}
        onRowClick={showDetails ?? pick}
        showInfoCta={Boolean(showDetails)}
        alignPriceColumn
        hidePriceLabel
        rightSlot={
          <Button
            variant={ctaVariant}
            size={isMobileView ? 'md' : 'sm'}
            label={ctaLabel}
            onClick={(e) => {
              // Keep the click from bubbling to onRowClick — one click, one action.
              e.stopPropagation();
              pick();
            }}
          />
        }
      />
    </li>
  );
};

export default ServiceItem;
